/**
 * システムアカウントの権限のタイプ.
 */
export const SystemAccountAuthorityType = {
  /** ROLE_ADMIN : 管理. */
  ROLE_ADMIN: 'ROLE_ADMIN',
  /** ROLE_OPER : 運用. */
  ROLE_OPER: 'ROLE_OPER',
  /** ROLE_VIEW : 閲覧. */
  ROLE_VIEW: 'ROLE_VIEW'
};

export type SystemAccountAuthorityType = typeof SystemAccountAuthorityType[keyof typeof SystemAccountAuthorityType];



// WEBPACK FOOTER //
// ./src/types/system-account-authority-type.ts